<template>
  <main id="renew3_mypage" v-if="true">
    <div class="mypage_back mypage_accountother">
      <div class="wrapper">
        <h2 class="m-h2">マイページ</h2>
        <p class="m-lead">マイページが新しくなりました。データバックアップ・復旧機能を利用したい場合は、<a href="/oldmypage" target="_blank"
            class="text-link">旧マイページ</a>にアクセスしてください。</p>

        <div class="my-contents sp">

          <mypagemenu-item viewFlag="my"></mypagemenu-item>

          <!--contents-->
          <div class="my-contents_container">
            <h2 class="m-h2">その他の設定</h2>
            <p class="m-lead">yagish（ヤギッシュ）に入力した下記のデータを削除できます。<br>
              ・ブラウザに保存されたデータ<br>
              ・サーバー上のバックアップデータ<br>
              ・登録したアカウント<br>
              ※ 削除を行うと元には戻せませんのでご注意ください。</p>

            <ul class="list">
              <li class="item">
                <div class="list_wrap">
                  <div class="flex item01">
                    <p class="item01-01">ヤギオファー停止</p>
                  </div>

                  <div class="item02">
                    <p class="item01-03">求人会社からのオファーを受信します。</p>
                    <div>
                      <el-switch v-model="yagiofferFlag" @change="updateYagiofferFlag" active-text="受信する"
                        inactive-text="受信しない"></el-switch>
                    </div>
                  </div>
                </div>
              </li>

              <li class="item">
                <div class="list_wrap">
                  <div class="flex item01">
                    <p class="item01-01">メルマガを停止</p>
                  </div>

                  <div class="item02">
                    <p class="item01-03">求人情報やおすすめ情報メールを受信します。</p>
                    <div>
                      <el-switch v-model="mailmagaFlag" @change="updateMailmagaFlag" active-text="受信する"
                        inactive-text="受信しない"></el-switch>
                    </div>
                  </div>
                </div>
              </li>

              <li class="item">
                <div class="list_wrap">
                  <div class="flex item01">
                    <p class="item01-01">ブラウザに保存されたデータを削除する</p>
                  </div>

                  <div class="item02">
                    <p class="item01-03">
                      このブラウザに保存されているyagish（ヤギッシュ）のデータを削除します。ネットカフェの共用パソコンなど、データを残したくない場合にご利用ください。削除するとデータは元に戻せません。必要な場合は事前にバックアップをおすすめします。
                    </p>
                    <div class="delete-confirm text-right" v-if="!clearLocalStorageConfirmVisible">
                      <el-button @click="clearLocalStorageConfirmVisible = true" type="danger"><i
                          class="el-icon-delete"></i> ブラウザのデータを削除する</el-button>
                    </div>
                    <div class="delete-confirm text-right" v-else>
                      <div style="text-align: right; margin: 0">
                        <el-button @click="clearLocalStorageConfirmVisible = false">キャンセル</el-button>
                        <el-button @click="clearLocalStorage();" type="danger"><i class="el-icon-delete"></i>
                          削除する</el-button>
                        <p>削除すると元には戻せませんのでご注意ください</p>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              <li class="item">
                <div class="list_wrap">
                  <div class="flex item01">
                    <p class="item01-01">サーバー上のバックアップを削除する</p>
                  </div>

                  <div class="item02" v-if="backupList.length">
                    <p class="item01-03">ログイン中のアカウント：<span>{{ $firebase.user.email }}</span><br>
                      <span>{{ backupList.length }}</span>件のバックアップがあります。<br>
                    </p>
                    <div v-if="backupList.length >= 100">
                      一度に削除できるのは100件までです。
                    </div>
                    <div class="delete-confirm text-right" v-if="!deleteBackupsConfirmVisible">
                      <el-button @click="deleteBackupsConfirmVisible = true" type="danger"><i
                          class="el-icon-delete"></i> {{ backupList.length }}件のバックアップを削除する</el-button>
                    </div>
                    <div class="delete-confirm" v-else>
                      <div style="text-align: right; margin: 0">
                        <el-button @click="deleteBackupsConfirmVisible = false">キャンセル</el-button>
                        <el-button @click="deleteBackups();" type="danger"><i class="el-icon-delete"></i>
                          削除する</el-button>
                        <p>削除すると元には戻せませんのでご注意ください</p>
                      </div>
                    </div>
                  </div>
                  <div class="item02" v-else-if="backupListLoaded">
                    <p>バックアップはありません</p>
                  </div>
                </div>
              </li>
              <li class="item" v-if="!isSubscribeCancel && isSubscribed">
                <div class="list_wrap">
                  <div class="flex item01">
                    <p class="item01-01">アカウントを削除する</p>
                  </div>
                  <div  class="item02" style="color:red;">
                    <p  class="item01-03">※無料相談へ応募のまま、退会したら希望したエージェントからの連絡を止めることができません。連絡を停止したい場合は、エージェントへの連絡もお願いします。</p>
                  </div>
                  <div class="item02">
                    <p class="item01-03">会員資格を終了するためには、先にヤギプライムを解除していただく必要がございます。</p>
                  </div>
                </div>
              </li>
              <li class="item" v-else>
                <div class="list_wrap">
                  <div class="flex item01">
                    <p class="item01-01">アカウントを削除する</p>
                  </div>
                  <div  class="item02" style="color:red;">
                    <p  class="item01-03">※無料相談へ応募のまま、退会したら希望したエージェントからの連絡を止めることができません。連絡を停止したい場合は、エージェントへの連絡もお願いします。</p>
                  </div>

                  <div class="item02">
                    <div v-if="backupList.length">
                      <p>アカウントを削除する前に『2. サーバー上のバックアップの削除』を行ってください。</p>
                    </div>
                    <div v-else-if="backupListLoaded">
                      <div class="delete-confirm text-right" v-if="!deleteUserConfirmVisible">
                        <el-button @click="deleteUserConfirmVisible = true" type="danger"><i class="el-icon-delete"></i>
                          {{ $firebase.user.email }} のアカウントを削除する</el-button>
                      </div>
                      <div class="delete-confirm" v-else>
                        <div style="text-align: right; margin: 0">
                          <el-button @click="deleteUserConfirmVisible = false">キャンセル</el-button>
                          <el-button @click="deleteUser();" type="danger"><i class="el-icon-delete"></i>
                            削除する</el-button>
                          <p>削除すると元には戻せませんのでご注意ください</p>
                        </div>
                      </div>
                      <div v-if="deleteUserFailed" class="delete-error">
                        <p>アカウントの削除に失敗するときは、ログイン情報が古い可能性があります。</p>
                        <p>お手数ですが、一度ログアウトし、ログインしなおしてから再度お試しください。</p>
                        <div class="text-right">
                          <el-button id="google-logout-account-dialog"
                            @click="$firebase.signOut(); $event.preventDefault()">ログアウト</el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              <li class="item" v-if="!isSubscribeCancel && isSubscribed">
                <div class="list_wrap">
                  <div class="flex item01">
                    <p class="item01-01">ヤギプライム会員資格を解約する</p>
                  </div>

                  <div class="item02">
                    <p class="item01-03">会員資格を終了すると、ヤギプライム特典が利用できなくなります。</p>
                    <a href="/yagiprimecancel" class="item02-01">解約する</a>
                  </div>
                </div>
              </li>

            </ul>

          </div>

          <mypagemenu-item viewFlag="service"></mypagemenu-item>

        </div>

        <div class="my-contents pc flex">
          <div class="menu-column">

            <mypagemenu-item viewFlag="my"></mypagemenu-item>

            <mypagemenu-item viewFlag="service"></mypagemenu-item>
          </div>

          <div class="right-contents">
            <!--contents-->
            <div class="my-contents_container">
              <h2 class="m-h2">その他の設定</h2>
              <p class="m-lead">yagish（ヤギッシュ）に入力した下記のデータを削除できます。<br>
                ・ブラウザに保存されたデータ<br>
                ・サーバー上のバックアップデータ<br>
                ・登録したアカウント<br>
                ※ 削除を行うと元には戻せませんのでご注意ください。</p>

              <ul class="list">
                <li class="item">
                  <div class="list_wrap">
                    <div class="flex item01">
                      <p class="item01-01">ヤギオファー停止</p>
                    </div>

                    <div class="item02">
                      <p class="item01-03">求人会社からのオファーを受信します。</p>
                      <div>
                        <el-switch v-model="yagiofferFlag" @change="updateYagiofferFlag" active-text="受信する"
                          inactive-text="受信しない"></el-switch>
                      </div>
                    </div>
                  </div>
                </li>

                <li class="item">
                  <div class="list_wrap">
                    <div class="flex item01">
                      <p class="item01-01">メルマガを停止</p>
                    </div>

                    <div class="item02">
                      <p class="item01-03">求人情報やおすすめ情報メールを受信します。</p>
                      <div>
                        <el-switch v-model="mailmagaFlag" @change="updateMailmagaFlag" active-text="受信する"
                          inactive-text="受信しない"></el-switch>
                      </div>
                    </div>
                  </div>
                </li>

                <li class="item">
                  <div class="list_wrap">
                    <div class="flex item01">
                      <p class="item01-01">ブラウザに保存されたデータを削除する</p>
                    </div>

                    <div class="item02">
                      <p class="item01-03">
                        このブラウザに保存されているyagish（ヤギッシュ）のデータを削除します。ネットカフェの共用パソコンなど、データを残したくない場合にご利用ください。削除するとデータは元に戻せません。必要な場合は事前にバックアップをおすすめします。
                      </p>
                      <div class="delete-confirm text-right" v-if="!clearLocalStorageConfirmVisible">
                        <el-button @click="clearLocalStorageConfirmVisible = true" type="danger"><i
                            class="el-icon-delete"></i> ブラウザのデータを削除する</el-button>
                      </div>
                      <div class="delete-confirm text-right" v-else>
                        <div style="text-align: right; margin: 0">
                          <el-button @click="clearLocalStorageConfirmVisible = false">キャンセル</el-button>
                          <el-button @click="clearLocalStorage();" type="danger"><i class="el-icon-delete"></i>
                            削除する</el-button>
                          <p>削除すると元には戻せませんのでご注意ください</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

                <li class="item">
                  <div class="list_wrap">
                    <div class="flex item01">
                      <p class="item01-01">サーバー上のバックアップを削除する</p>
                    </div>

                    <div class="item02" v-if="backupList.length">
                      <p class="item01-03">ログイン中のアカウント：<span>{{ $firebase.user.email }}</span><br>
                        <span>{{ backupList.length }}</span>件のバックアップがあります。<br>
                      </p>
                      <div v-if="backupList.length >= 100">
                        一度に削除できるのは100件までです。
                      </div>
                      <div class="delete-confirm text-right" v-if="!deleteBackupsConfirmVisible">
                        <el-button @click="deleteBackupsConfirmVisible = true" type="danger"><i
                            class="el-icon-delete"></i> {{ backupList.length }}件のバックアップを削除する</el-button>
                      </div>
                      <div class="delete-confirm" v-else>
                        <div style="text-align: right; margin: 0">
                          <el-button @click="deleteBackupsConfirmVisible = false">キャンセル</el-button>
                          <el-button @click="deleteBackups();" type="danger"><i class="el-icon-delete"></i>
                            削除する</el-button>
                          <p>削除すると元には戻せませんのでご注意ください</p>
                        </div>
                      </div>
                    </div>
                    <div class="item02" v-else-if="backupListLoaded">
                      <p>バックアップはありません</p>
                    </div>
                  </div>
                </li>
                <li class="item" v-if="!isSubscribeCancel && isSubscribed">
                  <div class="list_wrap">
                    <div class="flex item01">
                      <p class="item01-01">アカウントを削除する</p>
                    </div>
                  <div  class="item02" style="color:red;">
                    <p  class="item01-03">※無料相談へ応募のまま、退会したら希望したエージェントからの連絡を止めることができません。連絡を停止したい場合は、エージェントへの連絡もお願いします。</p>
                  </div>
                    <div class="item02">
                      <p class="item01-03">会員資格を終了するためには、先にヤギプライムを解除していただく必要がございます。</p>
                    </div>
                  </div>
                </li>
                <li class="item" v-else>
                  <div class="list_wrap">
                    <div class="flex item01">
                      <p class="item01-01">アカウントを削除する</p>
                    </div>
                  <div  class="item02" style="color:red;">
                    <p  class="item01-03">※無料相談へ応募のまま、退会したら希望したエージェントからの連絡を止めることができません。連絡を停止したい場合は、エージェントへの連絡もお願いします。</p>
                  </div>

                    <div class="item02">
                      <div v-if="backupList.length">
                        <p>アカウントを削除する前に『2. サーバー上のバックアップの削除』を行ってください。</p>
                      </div>
                      <div v-else-if="backupListLoaded">
                        <div class="delete-confirm text-right" v-if="!deleteUserConfirmVisible">
                          <el-button @click="deleteUserConfirmVisible = true" type="danger"><i
                              class="el-icon-delete"></i> {{ $firebase.user.email }} のアカウントを削除する</el-button>
                        </div>
                        <div class="delete-confirm" v-else>
                          <div style="text-align: right; margin: 0">
                            <el-button @click="deleteUserConfirmVisible = false">キャンセル</el-button>
                            <el-button @click="deleteUser();" type="danger"><i class="el-icon-delete"></i>
                              削除する</el-button>
                            <p>削除すると元には戻せませんのでご注意ください</p>
                          </div>
                        </div>
                        <div v-if="deleteUserFailed" class="delete-error">
                          <p>アカウントの削除に失敗するときは、ログイン情報が古い可能性があります。</p>
                          <p>お手数ですが、一度ログアウトし、ログインしなおしてから再度お試しください。</p>
                          <div class="text-right">
                            <el-button id="google-logout-account-dialog"
                              @click="$firebase.signOut(); $event.preventDefault()">ログアウト</el-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

                <li class="item" v-if="!isSubscribeCancel && isSubscribed">
                  <div class="list_wrap">
                    <div class="flex item01">
                      <p class="item01-01">ヤギプライム会員資格を解約する</p>
                    </div>

                    <div class="item02">
                      <p class="item01-03">会員資格を終了すると、ヤギプライム特典が利用できなくなります。</p>
                      <a href="/yagiprimecancel" class="item02-01">解約する</a>
                    </div>
                  </div>
                </li>

              </ul>

            </div>

          </div>
        </div>
      </div>
    </div>
  </main>
  <div class="container-base" v-else>
    <div class="pages setting">
      <h1>メルマガ停止、データ・アカウントの削除</h1>
      <p>{{ $site.name }}に入力した下記のデータを削除できます。</p>
      <ul>
        <li>ブラウザに保存されたデータ</li>
        <li>サーバー上のバックアップデータ</li>
        <li>登録したアカウント</li>
      </ul>
      <p>※ 削除を行うと元には戻せませんのでご注意ください</p>


      <div v-if="$firebase.isAuthenticated" class="setting-item">
        <h2>ヤギオファー停止</h2>
        <div>
          <p>求人会社からのオファーを受信します。</p>
        </div>
        <div>
          <el-switch v-model="yagiofferFlag" @change="updateYagiofferFlag" active-text="受信する"
            inactive-text="受信しない"></el-switch>
        </div>
        <h2>メルマガを停止する</h2>
        <div>
          <p>求人情報やおすすめ情報メールを受信します。</p>
        </div>
        <div>
          <el-switch v-model="mailmagaFlag" @change="updateMailmagaFlag" active-text="受信する"
            inactive-text="受信しない"></el-switch>
        </div>

      </div>
      <div v-else class="setting-item">
        <h2>メルマガを停止する</h2>
        <div>
          <p>メルマガを停止するためにはログインが必要です。</p>
          <login-forms />
        </div>
      </div>
      <div class="setting-item">
        <h2>1. ブラウザに保存されたデータを削除する</h2>
        <p>このブラウザに保存されている{{ $site.name }}のデータを削除します。</p>
        <p>ネットカフェの共用パソコンなど、データを残したくない場合にご利用ください。</p>
        <p>削除するとデータは元に戻せません。必要な場合は事前にバックアップをおすすめします。</p>
        <div class="delete-confirm text-right" v-if="!clearLocalStorageConfirmVisible">
          <el-button @click="clearLocalStorageConfirmVisible = true" type="danger"><i class="el-icon-delete"></i>
            ブラウザのデータを削除する</el-button>
        </div>
        <div class="delete-confirm text-right" v-else>
          <div style="text-align: right; margin: 0">
            <el-button @click="clearLocalStorageConfirmVisible = false">キャンセル</el-button>
            <el-button @click="clearLocalStorage();" type="danger"><i class="el-icon-delete"></i> 削除する</el-button>
            <p>削除すると元には戻せませんのでご注意ください</p>
          </div>
        </div>
      </div>

      <div v-if="$firebase.isAuthenticated" class="setting-item">
        <h2>2. サーバー上のバックアップを削除する</h2>
        <div v-if="backupList.length">
          <p>ログイン中のアカウント：{{ $firebase.user.email }}</p>
          <p>{{ backupList.length }}件のバックアップがあります。</p>
          <div v-if="backupList.length >= 100">
            一度に削除できるのは100件までです。
          </div>
          <div class="delete-confirm text-right" v-if="!deleteBackupsConfirmVisible">
            <el-button @click="deleteBackupsConfirmVisible = true" type="danger"><i class="el-icon-delete"></i> {{
    backupList.length }}件のバックアップを削除する</el-button>
          </div>
          <div class="delete-confirm" v-else>
            <div style="text-align: right; margin: 0">
              <el-button @click="deleteBackupsConfirmVisible = false">キャンセル</el-button>
              <el-button @click="deleteBackups();" type="danger"><i class="el-icon-delete"></i> 削除する</el-button>
              <p>削除すると元には戻せませんのでご注意ください</p>
            </div>
          </div>
        </div>
        <div v-else-if="backupListLoaded">
          <p>バックアップはありません</p>
        </div>

        <div class="setting-item" v-if="!isSubscribeCancel && isSubscribe">
          <h2>3. アカウントを削除する</h2>
          <div style="color:red;">
            <p >無料相談へ応募のまま、退会したら希望したエージェントからの連絡を止めることができません。<br>
            連絡を停止したい場合は、エージェントへの連絡もお願いします。</p>
          </div>
          <div>
            <p>アカウントを削除する前に『2. サーバー上のバックアップの削除』を行ってください。</p>
          </div>
        </div>
        <div class="setting-item" v-else>
          <h2>3. アカウントを削除する</h2>
          <div style="color:red;">
            <p >無料相談へ応募のまま、退会したら希望したエージェントからの連絡を止めることができません。<br>
            連絡を停止したい場合は、エージェントへの連絡もお願いします。</p>
          </div>
          <div v-if="backupList.length">
            <p>アカウントを削除する前に『2. サーバー上のバックアップの削除』を行ってください。</p>
          </div>
          <div v-else-if="backupListLoaded">
            <div class="delete-confirm text-right" v-if="!deleteUserConfirmVisible">
              <el-button @click="deleteUserConfirmVisible = true" type="danger"><i class="el-icon-delete"></i> {{
    $firebase.user.email }} のアカウントを削除する</el-button>
            </div>
            <div class="delete-confirm" v-else>
              <div style="text-align: right; margin: 0">
                <el-button @click="deleteUserConfirmVisible = false">キャンセル</el-button>
                <el-button @click="deleteUser();" type="danger"><i class="el-icon-delete"></i> 削除する</el-button>
                <p>削除すると元には戻せませんのでご注意ください</p>
              </div>
            </div>
            <div v-if="deleteUserFailed" class="delete-error">
              <p>アカウントの削除に失敗するときは、ログイン情報が古い可能性があります。</p>
              <p>お手数ですが、一度ログアウトし、ログインしなおしてから再度お試しください。</p>
              <div class="text-right">
                <el-button id="google-logout-account-dialog"
                  @click="$firebase.signOut(); $event.preventDefault()">ログアウト</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="not-authenticated setting-item">
        <div class="action">
          <p>サーバー上のバックアップ、アカウントの削除にはログインが必要です</p>
          <login-forms />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="css" src="@/assets/css/renew3_mypage.css"></style>


<script>
import LoginForms from '@/components/LoginSpecialForms'
import MypageCommonMenu from '@/components/formats/CommonParts/MypageCommonMenu'
export default {
  components: {
    'mypagemenu-item': MypageCommonMenu,
    'login-forms': LoginForms
  },
  data: function () {
    return {
      isSubscribed: false,
      isSubscribeCancel: false,
      deleteBackupsConfirmVisible: false,
      deleteUserConfirmVisible: false,
      deleteUserFailed: null,
      backupListLoaded: false,
      backupList: [],
      backupCount: 0,
      mailmagaFlag: true,
      yagiofferFlag: true,
      clearLocalStorageConfirmVisible: false
    }
  },
  methods: {
    clearLocalStorage: async function () {
      await this.$clearStorage()
      this.clearLocalStorageConfirmVisible = false
      const length = await this.$lengthOfStorage()
      if (length === 0) {
        this.$message({
          message: 'ブラウザ内のデータを削除しました',
          type: 'success'
        })
      } else {
        this.$message({
          message: 'ブラウザ内のデータを削除に失敗しました:' + length,
          type: 'error'
        })
      }
    },
    loadAllBackupList: async function () {
      if (!this.$firebase.isAuthenticated) {
        return
      }
      const app = this
      app.authStateChanged()
      app.backupListLoaded = false
      app.backupList = []
      await app.$firebase.getBackupList(null, 100)
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            const data = doc.data()
            app.backupList.push({
              id: doc.id,
              label: data.label,
              timestamp: data.timestamp,
              type: data.type,
              platform: data.platform
            })
          })
          app.backupListLoaded = true
        })
        .catch(function (err) {
          console.error(err)
        })
    },
    deleteBackups: async function () {
      try {
        for (const backup of this.backupList) {
          console.log(backup.id)
          await this.$firebase.deleteBackup(backup.id)
        }
      } catch (e) {
        console.error(e)
      }
      this.loadAllBackupList()
    },
    deleteUser: async function () {
      await this.$firebase.user.reload()
      await this.loadAllBackupList()
      await this.deleteBackups()
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      const deleteResult = this.$firebase.deleteUser()
      const app = this
      deleteResult.then(function () {
        app.$message({
          message: 'アカウントの削除に成功しました。ご利用ありがとうございました。',
          type: 'success'
        })
        app.$axios
          .post(app.$varuna.endPoints.deleteUser, formData)
        app.deleteUserConfirmVisible = false
        app.deleteUserFailed = false
        app.$router.push('/login')
      }).catch(function (error) {
        app.$message({
          message: 'アカウントの削除に失敗しました[' + error + ']',
          type: 'error'
        })
        app.deleteUserFailed = true
        console.error(error)
      }).finally(function () {
        app.$firebase.signOut()
      })
    },
    getMailmagaFlag: function (user) {
      const app = this
      if (this.$firebase.isAuthenticated) {
        console.error("mailmagaFlag:")
        const formData = new FormData()
        formData.append('uuid', this.$firebase.user.uid)
        this.$axios
          .post(this.$varuna.endPoints.getMailmagaFlag, formData, { timeout: 60000 })
          .then(function (response) {
            console.error(response.data)
            app.mailmagaFlag = response.data.mailmaga_flag == '1' ? true : false
          })
          .catch(function (error) {
          }).finally(function () {
          })
      }

    },
    updateMailmagaFlag: function (data) {
      if (this.$firebase.isAuthenticated) {
        const formData = new FormData()
        formData.append('uuid', this.$firebase.user.uid)
        formData.append('mailmaga_flag', data)

        this.$axios
          .post(this.$varuna.endPoints.updateMailmagaFlag, formData, { timeout: 60000 })
          .then(function (response) {
          })
          .catch(function (error) {
          }).finally(function () {
          })
      }

    },
    getYagiofferFlag: function (user) {
      const app = this
      if (this.$firebase.isAuthenticated) {
        console.error("yagiofferFlag:")
        const formData = new FormData()
        formData.append('uuid', this.$firebase.user.uid)
        this.$axios
          .post(this.$varuna.endPoints.getYagiofferFlag, formData, { timeout: 60000 })
          .then(function (response) {
            console.error(response.data)
            app.yagiofferFlag = response.data.yagioffer_flag == '1' ? true : false
          })
          .catch(function (error) {
          }).finally(function () {
          })
      }

    },
    updateYagiofferFlag: function (data) {
      if (this.$firebase.isAuthenticated) {
        const formData = new FormData()
        formData.append('uuid', this.$firebase.user.uid)
        formData.append('yagioffer_flag', data)

        this.$axios
          .post(this.$varuna.endPoints.updateYagiofferFlag, formData, { timeout: 60000 })
          .then(function (response) {
          })
          .catch(function (error) {
          }).finally(function () {
          })
      }

    },
    authStateChanged: async function () {
      const app = this
      this.$axios
        .get(this.$varuna.endPoints.isSubscribed + this.$firebase.user.uid + '/', null, { timeout: 60000 })
        .then(function (response) {
          console.error(response.data.is_subscribed)
          app.$globalVar.isYagiPrime = response.data.is_subscribed
          app.isSubscribed = response.data.is_subscribed
          app.isSubscribeCancel = response.data.is_cancel
        })
        .catch(function (error) {
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('firebase-initialized', this.loadAllBackupList)
    this.$eventHub.$on('mailmaga-flag-initialized', this.getMailmagaFlag)
    this.$eventHub.$on('yagioffer-flag-initialized', this.getYagiofferFlag)
    // this.loadAllBackupList()
  },
  destroyed: function () {
    this.$eventHub.$off('firebase-initialized', this.loadAllBackupList)
    this.$eventHub.$off('mailmaga-flag-initialized', this.getMailmagaFlag)
    this.$eventHub.$off('yagioffer-flag-initialized', this.getYagiofferFlag)
  }
}
</script>
